<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SearchJobNo')"
    width="960px"
    append-to-body
    :close-on-click-modal="false"
    class="app-main-inner edi-bill-search-selector"
  >
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form label-width="60px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('Payment.businessNumber')">
                <el-input v-model="elForm.jobNo" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('Payment.vessel')">
                <cargo-advance-select
                  filterable
                  allow-create
                  :select-type="selectTypeNames.basic_data_Vessel"
                  callback-method-type="value"
                  :default-value="elForm.vessel||''"
                  :callback-params="{key:'vessel'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('Payment.voyage')">
                <el-input v-model="elForm.voyageFlight" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('queryJob.dischargingPortCode')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Seaport"
                  callback-method-type="value"
                  :default-value="elForm.dischargingPortCodes||''"
                  :callback-params="{key:'dischargingPortCodes'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('Payment.consignationCompany')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{customer:true}"
                  callback-method-type="value"
                  :default-value="elForm.customerId||''"
                  :callback-params="{key:'customerId'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.ShippingCompany')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  callback-method-type="value"
                  :default-value="elForm.carrierId||''"
                  :callback-params="{key:'carrierId'}"
                  @parentCallBack="getValueFromChild"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('queryJob.dateOfDeparture')" class="custom-date">
                <div style="display: flex;justify-content: space-between; width: 246px;">
                  <el-date-picker
                    v-model="elForm.dfETD1"
                    type="date"
                    style="width:118px;"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="font-size: 12px;margin-left: 1px;margin-right: 1px;">-</span>
                  <el-date-picker
                    v-model="elForm.dfETD2"
                    type="date"
                    style="width:118px;"
                    clearable
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="MBL NO">
                <el-input v-model="elForm.mbl" style="width: 246px;" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item v-if="params.docType === 'MSC'" label="SONO">
                <el-input v-model="elForm.soNo" style="width: 240px;" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <el-button style="margin-left: -60px;" type="primary" @click="fetchAddress">{{ $t('common.btn.query') }}</el-button>
                <el-button type="primary" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:350px;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="searchConditions.total>0"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchAddress"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as ediApi from '@/api/seaExport/edi'
import { getJobByUuid } from '@/api/booking/job'
import { searchCargoDoc } from '@/api/seaExport/cargoDoc'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'SearchBillNoDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, default: '' },
    params: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      elForm: {
        jobNo: '',
        vessel: '',
        voyageFlight: '',
        mbl: '',
        dischargingPortCodes: '',
        customerId: '',
        carrierId: '',
        dfETD1: '',
        dfETD2: '',
        soNo: ''
      },
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNo'
        }, {
          headerName: this.$t('SeaExport.ShipperId'),
          tooltip: (params) => {
            return params.data.shipperCode
          },
          field: 'shipperCode'
        }, {
          headerName: this.$t('SeaExport.ShipperInfo'),
          tooltip: (params) => {
            return params.data.shipperLine
          },
          field: 'shipperLine'
        }, {
          headerName: this.$t('SeaExport.ConsigneeId'),
          tooltip: (params) => {
            return params.data.consigneeCode
          },
          field: 'consigneeCode'
        }, {
          headerName: this.$t('SeaExport.ConsigneeInfo'),
          tooltip: (params) => {
            return params.data.consigneeLine
          },
          field: 'consigneeLine'
        }, {
          headerName: this.$t('SeaExport.NotifyId'),
          tooltip: (params) => {
            return params.data.notifyCode
          },
          field: 'notifyCode'
        }, {
          headerName: this.$t('SeaExport.NotifyInfo'),
          tooltip: (params) => {
            return params.data.notifyLine
          },
          field: 'notifyLine'
        }
      ],
      rowData: [],
      selectedNode: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      gridApi: null,
      loading: null
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        // 清除单选行
        this.gridApi.clearFocusedCell()
      }
    }
  },
  methods: {
    getValueFromChild(obj) {
      this.elForm[obj.key] = obj.value
    },
    async fetchAddress() {
      const elForm = this.elForm
      const docType = this.params.docType
      let searchAllowed = true
      let sonoFilled = true
      if (docType === 'MSC') {
        sonoFilled = elForm.soNo !== null && elForm.soNo.trim() !== ''
      }
      searchAllowed = (elForm.jobNo !== null && elForm.jobNo.trim() !== '') || sonoFilled
      if (!searchAllowed) {
        this.$message.info(this.$t('SeaExport.PleaseBusinessNumberSearchCriteria'))
        return
      }
      this.loading = getLoading()
      const params = {}
      params.docType = docType
      params.branchId = this.$store.getters.currentOfficeId
      params.pageNum = this.searchConditions.pageNum
      params.pageSize = this.searchConditions.pageSize
      if (this.params.selectType === 'multiple') {
        const model = await this.fillModel()
        if (docType === 'MSC') {
          model.soNo = elForm.soNo
        }
        model.docType = docType
        model.branchId = this.$store.getters.currentOfficeId
        model.pageNum = this.searchConditions.pageNum
        model.pageSize = this.searchConditions.pageSize
        model.key = this.params.jobUuid
        ediApi.findNoJoinSeaExportJob(model)
          .then(result => {
            this.rowData = result.data.list
            this.searchConditions.total = parseInt(result.data.total)
          })
          .catch(message => {
            this.$message.error(message)
          })
      } else {
        if (elForm.jobNo !== null && elForm.jobNo.trim().length > 0) {
          params.jobNo = elForm.jobNo.trim()
        }
        if (elForm.mbl !== null && elForm.mbl.trim().length > 0) {
          params.mbl = elForm.mbl.trim()
        }
        if (elForm.vessel !== null && elForm.vessel.trim().length > 0) {
          params.vessel = elForm.vessel.trim()
        }
        if (elForm.voyageFlight !== null && elForm.voyageFlight.trim().length > 0) {
          params.voyageFlight = elForm.voyageFlight.trim()
        }
        if (elForm.customerId) {
          params.customerId = elForm.customerId
        }
        if (elForm.carrierId) {
          params.carrierId = elForm.carrierId
        }
        if (elForm.dischargingPortCodes !== null && elForm.dischargingPortCodes.trim().length > 0) {
          params.dischargingPortCode = elForm.dischargingPortCodes.trim()
        }
        if (elForm.dfETD1) {
          params.etdStart = elForm.dfETD1
        }
        if (elForm.dfETD2) {
          params.etdEnd = elForm.dfETD2
        }
        // 海运进口 单号抄录
        if (this.lob) {
          params.lob = this.lob
        }
        searchCargoDoc(params)
          .then(result => {
            this.rowData = result.data.list
            this.searchConditions.total = parseInt(result.data.total)
          })
          .catch(message => {
            this.$message.error(message)
          })
      }
      this.loading.close()
    },
    reset() {
      const elForm = this.elForm
      elForm.jobNo = ''
      elForm.vessel = ''
      elForm.voyageFlight = ''
      elForm.mbl = ''
      elForm.dischargingPortCodes = ''
      elForm.customerId = ''
      elForm.carrierId = ''
      elForm.dfETD1 = ''
      elForm.dfETD2 = ''
    },
    confirm() {
      this.$logger.log('selectedRow', this.selectedRow)
      if (!this.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // todo: 获取选择的数据  - 触发选择事件
      this.$emit('selected', this.selectedRow)
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
      this.reset()
    },
    async fillModel() {
      let defaultConditionByDocType = true
      const docType = this.params.docType
      const job = await getJobByUuid(this.params.jobUuid).then(res => {
        return res.data
      })
      const elForm = this.elForm
      if (docType === 'MBL2' || docType === 'HBL2') {
        defaultConditionByDocType = false
      }
      const model = {}
      if (elForm.jobNo !== null && elForm.jobNo.trim().length > 0) {
        model.jobNo = elForm.jobNo.trim()
      }
      if (elForm.mbl !== null && elForm.mbl.trim().length > 0) {
        model.mbl = elForm.mbl.trim()
      }
      if (elForm.vessel !== null && elForm.vessel.trim().length > 0) {
        model.vessel = elForm.vessel.trim()
      }
      if (elForm.voyageFlight !== null && elForm.voyageFlight.trim().length > 0) {
        model.voyageFlight = elForm.voyageFlight.trim()
      }
      if (elForm.vessel !== null && elForm.vessel.trim().length > 0) {
        model.vessel = elForm.vessel.trim()
      }
      if (elForm.voyageFlight !== null && elForm.voyageFlight.trim().length > 0) {
        model.voyageFlight = elForm.voyageFlight.trim()
        if (!defaultConditionByDocType) {
          model.voyage = elForm.voyageFlight.trim()
        }
      }
      if (elForm.customerId) {
        model.customerId = elForm.customerId
      }
      if (elForm.carrierId) {
        model.carrierId = elForm.carrierId
      }
      if (elForm.dischargingPortCodes !== null && elForm.dischargingPortCodes.trim() !== '') {
        model.dischargingPortCode = elForm.dischargingPortCodes.trim()
      }
      if (job && job.loadingPortCode.length > 0 && defaultConditionByDocType) {
        model.loadingPortCode = job.loadingPortCode
      }
      if (job && job.destinationAgent > 0 && defaultConditionByDocType) {
        model.destinationAgent = job.destinationAgent
      }
      if (elForm.dfETD1) {
        model.etdStart = elForm.dfETD1
      }
      if (elForm.dfETD2) {
        model.etdEnd = elForm.dfETD2
      }
      if (!elForm.dfETD1 && !elForm.dfETD2 && defaultConditionByDocType) {
        model.etdStart = job.ETD
        model.etdEnd = job.ETD
      }
      model.opDepartment = job.opDepartment
      return model
    }
  }
}
</script>

<style lang="scss">
.edi-bill-search-selector {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
}
</style>
